export const COLUMNS = {
  AUDIO: 'link',
  NAME: 'fileName',
  CONTEXT: 'runContext',
  STEP: 'step',
  METADATA_KEY: 'metadata',
  ACTIONS: 'rowActionMenu'
};

export const DEFAULT_COLUMNS = [
  {
    name: COLUMNS.AUDIO,
    title: 'Audio',
    type: 'string'
  },
  {
    name: COLUMNS.NAME,
    title: 'Name',
    type: 'string'
  },
  {
    name: COLUMNS.CONTEXT,
    title: 'Context',
    type: 'string'
  },
  {
    name: COLUMNS.STEP,
    title: 'Step',
    type: 'string'
  }
];

export const SUFFIX_COLUMNS = [
  {
    name: COLUMNS.ACTIONS,
    title: '  ',
    type: 'string'
  }
];

export const RIGHT_COLUMNS = [COLUMNS.ACTIONS];
